import { Formik, Form} from 'formik';
import { useNavigate, useParams } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { useSelector,useDispatch } from "react-redux";
import { setSwitchRegion  } from "../../redux/authSlice";
import { api } from '../../api';
import { EditMerchantSchema } from '../../validation/ValidationSchema';
import { getAllCountries, getStateByCountry } from '../../helpers/countryState';
import { getBase64 } from '../../utils/converter';
import { toast } from "react-toastify";
import ButtonContained from '../button';
import DropdownComp from '../dropdown';
import Input from '../input';
import Modal from '../modals/Modal';
import Swal from "sweetalert2";


const EditMerchantRequest = props => {
    const token = useSelector((state) => state.auth.token);
    const region = useSelector((state) => state.auth.region);
    const dispatch = useDispatch();
   
    const [loading, setLoading] = useState(true)
    const countrydata = getAllCountries();
    const [countries] = useState(countrydata)
    const [states, setStates] = useState([])
    // eslint-disable-next-line 
    const [init, setInitialize] = useState([])
    // eslint-disable-next-line 
    const [isEditing, setEditing] = useState(false)
    const navigate = useNavigate();
    const fileInputRefs = useRef([]);
    const [taxLabel, setTaxLabel] = useState('Tax Number');
    const [taxType, setTaxType] = useState('Tax Type');

    const [merchent, setMerchent] = useState({})
     // eslint-disable-next-line 
    const [updateData, setUpdateData] = useState(false)

    const { id: merchentId } = useParams(); // Rename 'id' to 'merchentId'

    useEffect(() => {
        dispatch(setSwitchRegion(false));
    
        return () => {
            dispatch(setSwitchRegion(true)); // reset when unmounting
        };
        }, [dispatch]);

    useEffect(() => {
        api.merchants.getMerchantsRequestById({ merchentId: merchentId }, token).then(merchent => {
            setMerchent(merchent.data);
            setLoading(false)
            
        }).catch(err => {
            toast.error("Merchant request not found");
            navigate('/merchant-requests');

        })
        // eslint-disable-next-line
    }, [merchentId,token])


       useEffect(() => {
        // eslint-disable-next-line
        if (region?.id == "1") {
          setTaxLabel('GST Number');
          setTaxType('GST');
          // eslint-disable-next-line
        } else if (region?.id == "2") {
          setTaxLabel('VAT Number');
          setTaxType('VAT');
        } else {
          setTaxLabel('Tax Number');
          setTaxType('VAT');
    
        }
      }, [region]);

       //doc upload data
       const [documentOptions, setDocumentOptions] = useState([]);
       useEffect(() => {
        const fetchDocumentTypes = async () => {
            try {
            const response = await api.resellerType.getDocumentTypesByRegionId(
                { resellerRegionId: region.id },
                null
            );
        
            if (response.success === true) {
                setDocumentOptions(response.data);
            } else {
                setDocumentOptions([]);
            }
            } catch (error) {
            console.error('Error fetching document types:', error);
            setDocumentOptions([]);
            }
        };

      
            fetchDocumentTypes();
        
        }, [token,region.id]);
        
    
         const [documents, setDocuments] = useState([
           { documentTypeId: '', fileName: null , id: null }
         ]);
         
         const handleAddDocument = () => {
           const hasIncomplete = documents.some(doc => !doc.documentTypeId || !doc.fileName);
           if (hasIncomplete) {
             toast.error('Please complete all existing document entries before adding a new one.');
             return;
           }
         
           if (documents.length < 5) {
           setDocuments([
             ...documents,
             { documentTypeId: '', fileName: null, id: null }
           ]);
           }
         };
         
         const handleRemoveDocument = async(index) => {
           const docToRemove = documents[index];
                Swal.fire({
                title: "Remove Document",
                text: "Are you sure to remove?",
                confirmButtonText: 'Yes',
                confirmButtonColor: "#5C2E91",
                showCancelButton: true,
                cancelButtonText: 'Cancel'
                }).then(async(result) => {
                    if (result.isConfirmed) {
                        if (docToRemove.id !== null) {

                            try {
                            const payload = { id: docToRemove.id };
                            await api.merchants.deleteMerchentRequestDocuments(payload, token);
                            toast.success('Document deleted successfully.');
                            } catch (error) {
                            toast.error('Failed to delete document.');
                            console.error('Delete error:', error);
                            }
                        }

                        const updated = documents.filter((_, i) => i !== index);
                        setDocuments(updated);
                    }
                });
      
         };
         
         const handleDocumentChange = (index, field, value) => {
           if (field === 'documentTypeId') {
            
            
              const isDuplicate = documents.some((doc, i) => {
                // eslint-disable-next-line
                return doc.documentTypeId == value && i !== index;
                });
             if (isDuplicate) {
               toast.error('This document type is already selected.');
               return;
             }
           }
         
         
           const newDocs = [...documents];
         
           if (field === 'file') {

            const file = value;

            const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
            const maxSizeInBytes = 1 * 1024 * 1024; // 1 MB

            if (!allowedTypes.includes(file.type)) {
                toast.error('Invalid file type. Only PDF, JPEG, and PNG are allowed.');
                if (fileInputRefs.current[index]) fileInputRefs.current[index].value = '';
                return;
            }

            if (file.size > maxSizeInBytes) {
                toast.error('File size must be less than 1MB.');
                if (fileInputRefs.current[index]) fileInputRefs.current[index].value = '';
                return;
            }
         
             getBase64(file, async(base64) => {
           
             const docTypeId = newDocs[index]['documentTypeId'];
               if(docTypeId !== null & docTypeId !== '' & docTypeId !== undefined){
               try {
                    const payload = {
                    documentTypeId: docTypeId,
                    merchentRequestId: merchentId, // make sure this is accessible in the scope
                    fileName: base64
                    };
                    const responseAddDoc = await api.merchants.addMerchantRequestDocuments(payload, token);
                    if(responseAddDoc.success){
                    toast.success('Document uploaded successfully.');
                     fetchDocumentOptions();
                    }
                    
                   
                } catch (error) {
                    toast.error('Failed to upload document.');
                    console.error('Upload error:', error);
                }
               }else{
                toast.error('Document Type Required');
               }
    
             });

              


           } else {
             newDocs[index][field] = value;
             setDocuments(newDocs);
           }
          
           };



            useEffect(() => {
            
                if (merchentId) {
                    fetchDocumentOptions();
                }
                 // eslint-disable-next-line
                }, [merchentId]);


              const fetchDocumentOptions = async () => {
                    try {
                    const responseDoc = await api.merchants.getDocsByMerchentRequestId(
                        { merchentRequestId: merchentId },
                        token
                    );

                    if (responseDoc.success && Array.isArray(responseDoc.data)) {
                        
                        const mappedDocuments = responseDoc.data.map(doc => ({
                        documentTypeId: doc.documentTypeId,
                        fileName: doc.fileName,
                        id: doc.id
                        }));

                        setDocuments(mappedDocuments); // update your state here
                    } else {
                        setDocuments([]); // clear if empty or failed
                    }
                    } catch (error) {
                    console.error('Error fetching documents:', error);
                    setDocuments([]); // clear on error
                    }
                };


    
    
       // doc upload end
    



    useEffect(() => {
        if (init && init.length > 0) {
            setLoading(false)
        }
    },[init])
    const getCurrentCountryValue = (value, list) => {
        const currentValue = list.find(lst => lst.value === value)
        return currentValue
    }

    const [openModal, setOpenModal] = useState(false)
    // eslint-disable-next-line
    const [headerName, setHeaderName] = useState('')
    // eslint-disable-next-line
    const [fileName, setFileName] = useState('')
    // eslint-disable-next-line 
    const { userType: role } = useSelector((state) => state.auth.user);


    const cdn_path =  `${process.env.REACT_APP_PREVIEW_URL}${process.env.REACT_APP_UPLOAD_PATH}`;



    function viewProof(headerName, fileName) {
         const fileurl = `${cdn_path}${fileName}`; 
         window.open(fileurl, '_blank');
        // const isPdf = fileName.toLowerCase().endsWith('.pdf');
        // if (isPdf) {
        // const pdfUrl = `${cdn_path}${fileName}`; 
        // window.open(pdfUrl, '_blank'); // Open in a new tab

        // }else{
        // setHeaderName(headerName);
        // setFileName(fileName);
        // setOpenModal(true);
        // }
        
    }

    function closeModalPopUp() {
        setOpenModal(false);
       
    }

    function acceptRequest() {
        const formBody = {
            merchentId: merchentId,
        }
        setLoading(true);
        api.merchants.acceptMerchantsRequest(formBody,token).then(res => {
            if (res.success === false) {
                 toast.error(res.message);
            }
            else {
                toast.success(res.message);
                navigate('/merchant-requests')
            }
            // closeModal()
            setLoading(false);
        }).catch(err => {
            toast.error("Something went wrong");
            // closeModal()

        });

    }

    
    if (loading) {
        return <div> Loading... </div>
    }
    return (
        // <Modal
        //     id="trans-history"
        //     showModal={showEditMerchantModal}
        //     closeModal={closeModal}
        //     modalHeader="Edit Merchant"
        //     buttonText="SAVE">
        <Formik
            enableReinitialize
            validationSchema={EditMerchantSchema}
            initialValues={{
                merchantName: merchent.merchantName || "",
                address: merchent.merchantAddress || "",
                country: getCurrentCountryValue(merchent.merchantCountry, countries) || "",
                state: getCurrentCountryValue(merchent.merchantState, getStateByCountry(merchent.merchantCountry)) || "",
                city: merchent.merchantCity || "",
                pincode: merchent.merchantPincode || "",
                mobileNumber: merchent.merchantMobile || "",
                phone: merchent.merchentPhone || "",
                contactPerson: merchent.merchantContactPerson || "",
                emailAddress: merchent.merchantEmail || "",
                gstNumber: merchent.merchantGstNo || "",
                token: merchent.merchantToken || "",
                authorizationCode: merchent.merchantAuthorization || "",
                password: merchent.password,
                merchentId: merchentId,
                territory: merchent.merchantTerritory || '',
                exclusive: merchent.merchantExclusive || '',
                minWallet: merchent.merchantMinWallet || '',
                validityPeriod: merchent.merchantValidityPeriod || '',
                rollForecast: merchent.merchantRollForecast || '',
                additionalItem: merchent.merchantAdditionalItem || '',
                resellerType: region.name || '',
                documents: [{ documentTypeId: '', fileName: null,id:null }],
                taxNumber:merchent.merchentTaxNumber || '',
               

            }}


            onSubmit={(values, actions) => {
           
                // console.log(values.brandAccess)
              
                const formBody = {
                    merchentId: merchentId,
                    merchantName: values.merchantName,
                    merchantAddress: values.address,
                    merchantCountry: values.country.value || '',
                    merchantState: values.state.value || '',
                    merchantPincode: values.pincode,
                    merchantCity: values.city,
                    merchantMobile: values.mobileNumber,
                    merchantPhone: values.phone,
                    merchantContactPerson: values.contactPerson,
                    merchantEmail: values.emailAddress,
                    merchantGst: values.gstNumber,
                    merchantTerritory: values.territory,
                    merchantExclusive: values.exclusive,
                    merchantMinWallet: values.minWallet,
                    merchantValidityPeriod: values.validityPeriod,
                    merchantRollForecast: values.rollForecast,
                    merchantAdditionalItem: values.additionalItem,
                    merchentTaxNumber:values.taxNumber,
                    merchentTaxType:taxType
      

                }
               
                // console.log(formBody)
                api.merchants.updateMerchantsRequest(formBody,token).then(res => {
                    if (res.success === false) {
                         toast.error(res.message);
                    }
                    else {
                        toast.success(res.message);
                        navigate('/merchant-requests')
                    }
                    // closeModal()
                    setUpdateData(true)
                }).catch(err => {
                    toast.error("Something went wrong");
                    // closeModal()

                })
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
                isSubmitting,
                setFieldValue

            }) => {
                return (
                    <div className="container-fluid">
                        {/* <section className="mt-4"> */}
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="box-row">
                                    <div className="table-head">
                                        <h1 className="sec-header">EDIT MERCHANT REQUEST</h1>
                                    </div>
                                    <div className="card card-table">
                                        <div className="card-body gatepass-saveoutput">
                                            <div className="reports">
                                                <Form onSubmit={handleSubmit}>
                                                    <div className="form-row">
                                                        <div className="form-group col-md-4">                                                                                                                                                        
                                                                                                                
                                                            <Input
                                                                name="resellerType"
                                                                id="resellerType"
                                                                label="Reseller Region"
                                                                placeholder="Reseller Region"
                                                                type="text"
                                                                value={values.resellerType}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                name="merchantName"
                                                                id="merchantName"
                                                                placeholder="Enter merchant name"
                                                                type="text"
                                                                label="Merchant Name"
                                                                value={values.merchantName}
                                                                onChange={handleChange}
                                                                error={touched.merchantName && errors.merchantName}
                                                                errorText={errors.merchantName}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="address"
                                                                name="address"
                                                                placeholder="Enter address"
                                                                type="text"
                                                                label="Address"
                                                                value={values.address}
                                                                onChange={handleChange}
                                                                error={touched.address && errors.address}
                                                                errorText={errors.address}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                       

                                                    </div>
                                                    <div className="form-row">
                                                         <div className="form-group col-md-4">
                                                            <Input
                                                                id="city"
                                                                name="city"
                                                                placeholder="Enter city"
                                                                type="text"
                                                                label="City"
                                                                value={values.city}
                                                                onChange={handleChange}
                                                                error={touched.city && errors.city}
                                                                errorText={errors.city}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <DropdownComp
                                                                name="country"
                                                                id="country"
                                                                label="Country"
                                                                placeholder="Please select"
                                                                onChange={(selectedValue) => {
                                                                    setFieldValue("country", selectedValue)
                                                                    setFieldValue("state", "")
                                                                    const stateList = getStateByCountry(selectedValue.value)
                                                                    setStates(stateList)
                                                                }}
                                                                value={values.country}
                                                                options={countries}
                                                                error={touched.country && errors.country}
                                                                errorText={errors.country}
                                                                disabled={isSubmitting}>
                                                            </DropdownComp>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <DropdownComp
                                                                id="state"
                                                                name="state"
                                                                onChange={(selectedValue) => {
                                                                    setFieldValue("state", selectedValue)
                                                                }}
                                                                value={values.state}
                                                                label="State"
                                                                placeholder="Please select"
                                                                options={states}
                                                                error={touched.state && errors.state}
                                                                errorText={errors.state}
                                                                disabled={isSubmitting}>
                                                            </DropdownComp>
                                                        </div>

                                                     


                                                       
                                                    </div>
                                                    <div className="form-row">

                                                    <div className="form-group col-md-4">
                                                        <Input
                                                            id="pincode"
                                                            name="pincode"
                                                            placeholder="Enter Pincode"
                                                            type="text"
                                                            label="Pincode"
                                                            value={values.pincode}
                                                            onChange={handleChange}
                                                            error={touched.pincode && errors.pincode}
                                                            errorText={errors.pincode}
                                                            disabled={isSubmitting} />
                                                    </div>


                                                    <div className="form-group col-md-4">
                                                            <Input
                                                                id="mobileNumber"
                                                                name="mobileNumber"
                                                                placeholder="Enter mobile number"
                                                                type="number"
                                                                label=" Mobile Number"
                                                                value={values.mobileNumber}
                                                                onChange={handleChange}
                                                                error={touched.mobileNumber && errors.mobileNumber}
                                                                errorText={errors.mobileNumber}
                                                                disabled={isSubmitting} />
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="contactPerson"
                                                                name="contactPerson"
                                                                placeholder="Enter contact person"
                                                                type="text"
                                                                label="Contact Person"
                                                                value={values.contactPerson}
                                                                onChange={handleChange}
                                                                error={touched.contactPerson && errors.contactPerson}
                                                                errorText={errors.contactPerson}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="emailAddress"
                                                                name="emailAddress"
                                                                placeholder="Email (Login Id)"
                                                                type="text"
                                                                label="Email (Login Id)"
                                                                value={values.emailAddress}
                                                                onChange={handleChange}
                                                                // error={touched.emailAddress && errors.emailAddress}
                                                                // errorText={errors.emailAddress}
                                                                disabled={isSubmitting} />
                                                        </div>

                                                      

                                                    </div>

                                                    <h1 className="section-header float-left">Other Information</h1>
                                                    <div className="form-row">

                                                    <div className="form-group col-md-4">
                                                            <Input
                                                                id="territory"
                                                                name="territory"
                                                                placeholder="Territory"
                                                                type="text"
                                                                label="Territory"
                                                                value={values.territory}
                                                                onChange={handleChange}
                                                                // error={touched.emailAddress && errors.emailAddress}
                                                                // errorText={errors.emailAddress}
                                                                disabled={isSubmitting} />
                                                        </div>

                                                        
                                                    <div className="form-group col-md-4">  
                                                    <Input
                                                    style={{ width: '100%' }}
                                                    id="exclusive"
                                                    name="exclusive"
                                                    placeholder="NA"
                                                    type="text"
                                                    label="Exclusivity (if applicable)"
                                                    value={values.exclusive}
                                                    disabled={isSubmitting}  // Input is disabled
                                                    />
                                                    </div>

                                                    
                                                    <div className="form-group col-md-4">  
                                                    <Input
                                                    style={{ width: '100%' }}
                                                    id="minWallet"
                                                    name="minWallet"
                                                    placeholder="NA"
                                                    type="text"
                                                    label="Minimum Wallet Balance"
                                                    value={values.minWallet}
                                                    disabled={isSubmitting}  // Input is disabled
                                                    />
                                                    </div>

                                                    <div className="form-group col-md-4">  
                                                    <Input
                                                    style={{ width: '100%' }}
                                                    id="validityPeriod"
                                                    name="validityPeriod"
                                                    placeholder="NA"
                                                    type="text"
                                                    label="Validity Period"
                                                    value={values.validityPeriod}
                                                    disabled={isSubmitting}  // Input is disabled
                                                    />
                                                    </div>

                                                    <div className="form-group col-md-4">  
                                                    <Input
                                                    style={{ width: '100%' }}
                                                    id="rollForecast"
                                                    name="rollForecast"
                                                    placeholder="NA"
                                                    type="text"
                                                    label="Rolling Forecast"
                                                    value={values.rollForecast}
                                                    disabled={isSubmitting}  // Input is disabled
                                                    />
                                                    </div>

                                                    <div className="form-group col-md-4">  
                                                    <Input
                                                    style={{ width: '100%' }}
                                                    id="additionalItem"
                                                    name="additionalItem"
                                                    placeholder="NA"
                                                    type="text"
                                                    label="Specific/Additional Terms (if any)"
                                                    value={values.additionalItem}
                                                    disabled={isSubmitting}  // Input is disabled
                                                    />
                                                    </div>

                                                  
                                                     <div className="form-group col-md-4">
                                                          <Input
                                                            name="taxNumber"
                                                            placeholder={taxLabel}
                                                            type="text"
                                                            label={taxLabel}
                                                            value={values.taxNumber}
                                                            onChange={handleChange}
                                                            id="taxNumber"                                                              
                                                            />
                                                      
                                                        </div>
                                                         

                                                    
                                                        
                                                    </div>

                                                    {/* Document Upload */}

                                                    <h1 className="section-header float-left">Document Upload</h1>

                                                    
                                                    <div className="form-row">
                                             
                                                    

                                                        {documents.map((doc, index) => (
                                                        <div className="form-group col-md-12 row" key={index}>
                                                            <div className="col-md-3">
                                                            <label>Document Type</label>
                                                            <select
                                                                className="form-control"
                                                                value={doc.documentTypeId}
                                                                onChange={(e) => handleDocumentChange(index, 'documentTypeId', e.target.value)}
                                                                style={{   minWidth: "100px",
                                                                height: "35px",
                                                                padding: "5px 15px",
                                                                lineHeight: "18px",
                                                                appearance: "auto", // ensures default arrow shows in most browsers
                                                                WebkitAppearance: "auto",
                                                                MozAppearance: "auto",}}
                                                            >
                                                                <option value="">Select Document</option>
                                                                {documentOptions.map((option, idx) => (
                                                                <option key={idx} value={option.documentId}>{option.documentType}</option>
                                                                ))}
                                                            </select>

                                                                {errors.documents?.[index]?.documentTypeId && (
                                                                    <small className="text-danger">{errors.documents[index].documentTypeId}</small>
                                                                )}
                                                                </div>

                                                            {doc.id === null && (

                                                            <div className="col-md-4">
                                                            <label>Upload File</label>
                                                            <input
                                                                type="file"
                                                                className="form-control-file  rounded"
                                                                onChange={(e) => handleDocumentChange(index, 'file', e.target.files[0])}
                                                                ref={(el) => (fileInputRefs.current[index] = el)}
                                                            />

                                                            {errors.documents?.[index]?.file && (
                                                                <small className="text-danger">{errors.documents[index].file}</small>
                                                            )}

                                                            
                                                            </div>

                                                             )}

                                                             <div className="col-md-2">
                                                                <button className="btn submit-btn" variant="primary" type="button" onClick={() => viewProof('Document', doc.fileName)} style={{ width: "max-content",marginTop:'30px',lineHeight:'16px' }}> Views</button>
                                                            </div>

                                                            <div className="col-md-2">
                                                         
                                                        
                                                            <i className="fa fa-trash" aria-hidden="true" style={{ color: "#e60b0b", marginTop:"38px"}}  onClick={() => handleRemoveDocument(index)}></i>
                                                           
                                                        </div>
                                                        

                                                        
                                                                </div>
                                                            ))}

                                                    

                                                        <div className="form-group col-md-12">
                                                        {documents.length < 5 && (
                                                        <button type="button" className="login-btn1 btn mt-3" onClick={handleAddDocument}>
                                                            <i className="fa fa-plus" aria-hidden="true"  style={{ color: "#fff"}}></i> Add New Document
                                                        </button>
                                                        )}
                                                        </div>
                                                    
                                                    </div>
                                                  

                                        
                                                    {merchent.merchantStatus === 0 && (
                                                    <div>
                                                        <ButtonContained buttonName="Update" disabled={isSubmitting} /> 
                                                        <button type="button" className="btn submit-btn" style={{ marginTop:"20px", marginLeft:"10px" }} onClick={() => acceptRequest()}>Accept </button>
                                                    </div>
                                                     )}
                                                </Form>


                                    {openModal && <Modal
                                        modalHeader={headerName}
                                        showModal={openModal}
                                        closeModal={closeModalPopUp}
                                    // buttonText="SAVE"
                                    >
                                        <img src={`${cdn_path}${fileName}`} alt="nodwin" height="100%" width="100%" />
                                    </Modal>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* </section> */}
                    </div>

                )
            }}
        </Formik >
        // </Modal>

        
    );
}

export default EditMerchantRequest;